<div class="container mb-1">
    <h5 class="title-step-2 animated fadeIn delay" align="center">
        <img src="./assets/img/package.svg" class="img-fluid ico-title" width="22"> Ofertas para el cliente
    </h5>


    <!-- Solo fibra -->
    <ng-container *ngIf="type === 'ftth' && typeOrder == 'broadband'">
        <div class="row justify-content-center animated fadeIn delay-1s" *ngIf="this.rateMaster">

            <div class="col-lg-4" *ngFor="let rate of this.rateMaster.ftth">
                <div class="card-tar card-white mb-4">
                    <div class="card-tar-header rm-verde">
                        <div class="d-flex justify-content-between align-items-center">
                            <h5 align="center" class="tar-name">{{ rate.name }}</h5>
                            <small class="text-muted">
                                <h5 *ngIf="rateFtth !== null" align="center" class="tar-name">
                                    {{ priceWithIVA(rate.rateAmount - rateFtth.discount).toFixed(0) }}
                                    <span class="eu2"> €/mes</span>
                                </h5>
                                <h5 *ngIf="rateFtth === null" align="center" class="tar-name">
                                    {{ priceWithIVA(rate.rateAmount).toFixed(0) }}
                                    <span class="eu2"> €/mes</span>
                                </h5>
                            </small>
                        </div>
                    </div>

                    <div class="card-tar-body">
                        <ul class="mb-5">
                            <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelData">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                {{ rate.resumeLabelData }}
                            </h5>
                            <h5 align="left" class="tar-name-pricing" *ngIf="rate.labelData && rate.resumeLabelData == null">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                {{ rate.labelData }}
                                <b *ngIf="rate.sublabelData">{{ rate.sublabelData }}</b>
                            </h5>
                            <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelVoice">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                <b> {{ rate.resumeLabelVoice }}</b>
                            </h5>
                        </ul>
                        <div style="margin-top: -15px;">
                            <button (click)="selectRate(rate)" class="btn btn-green btn-sm btn-block">Seleccionar</button>
                            <button class="btn btn-grey btn-sm btn-block" (click)="modalMoreInfo(rate)">Más info</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center col-lg-8 offset-md-2 div-pack">
            <a class="btn btn-black btn-blok mb-1 btn-pack w-100" (click)="switchToConvergent()" role="button">
                ¡Convierte la Fibra en un pack de Fibra y línea Móvil!
            </a>
        </div>
    </ng-container>



    <!-- Convergente -->
    <!--<div class="row  animated fadeIn delay-1s" *ngIf="type === 'ftth'  && typeOrder == 'convergent'">-->
        <!--<div align="center" class="col-md-6 offset-md-3" style="margin-top: -30px;">-->
            <!--<h6 class="localidad-norm">Elige velocidad</h6>-->

            <!--<div align="center" class="radio-btn-group2 mb-5">-->
                <!--<div class="radio" *ngFor="let rate of this.rateMaster.ftth, index as i">-->
                    <!--<input id="rate_{{ rate.packageId }}" type="radio" name="radio" value="{{ i }}" (click)="showFtthRate(i)"/>-->
                    <!--<label for="rate_{{ rate.packageId }}"><b>{{ rate.name }}</b></label>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
    <!--</div>-->


    <!-- solo móvil -->
    <div class="row animated fadeIn delay-1s" *ngIf="type === 'mobile' && this.rateMaster && loaded">
        <div align="center" class="col-md-6 offset-md-3" style="margin-top: -30px;">
            <h6 class="localidad-norm">Elige</h6>

            <div align="center" class="radio-btn-group2 mb-5">
                <div class="radio">
                    <input id="rate_pre" type="radio" name="radio" value="prepaid" (click)="showRates($event.target.value)"/>
                    <label for="rate_pre"><b>Prepago</b></label>
                </div>
                <div class="radio">
                    <input id="rate_post" type="radio" name="radio" value="postpaid" (click)="showRates($event.target.value)"/>
                    <label for="rate_post"><b>Pospago</b></label>
                </div>
            </div>

        </div>
    </div>
</div>


<!-- Zona de cajitas para escoger tarifa (fibra, móvil ó packs) -->
<div id="tar100" class="tarifas100 mb-5" *ngIf="rates != null && rates.length > 0">
    <div class="alert alert-primary bg-black div-promo" role="alert" *ngIf="showOffer && (contractType === 'postpaid' || (typeOrder === 'convergent' && contractType !== 'prepaid'))">
        <h6 align="center" class="pt-2 pb-1 div-promo">
            <span class="pe-4 white" style="font-size: 19px;">+30Gb GRATIS para altas realizadas hasta el 31 de agosto</span>
            <a class="cursor-pointer" (click)="openModalOffer(modalOffer)">
                <img src="./assets/img/info-white.svg" class="img-fluid ico-title" width="20">
            </a>
        </h6>
    </div>
    <div class="row justify-content-center ">
        <!-- Si convergente, construimos packs -->
        <ng-container *ngIf="type === 'ftth' && typeOrder == 'convergent'; else other_rates">
            <ng-container *ngFor="let rate of rates">
                <div class="col-lg-4" *ngFor="let mobileRate of rate.mobileRates">
                    <div class="card-tar card-white mb-4">
                        <div class="card-tar-header rm-verde">
                            <div class="d-flex justify-content-between align-items-center">
                                <h5 align="center" class="tar-name">
                                    <span>{{ rate.name }}</span>
                                    <br>
                                    <div style="text-align: left;">+ {{ mobileRate.name }}</div>
                                </h5>
                                <small class="text-muted">
                                    <h5 align="center" class="tar-name">
                                        {{ priceWithIVA(+rate.rateAmount + +mobileRate.rateAmount - +rate.discount).toFixed(0) }}
                                        <span class="eu2"> €/mes</span>
                                    </h5>
                                </small>
                            </div>
                        </div>

                        <div class="card-tar-body">
                            <ul class="mb-5">
                                <!-- info FTTH -->
                                <!-- <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelData">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    {{ rate.resumeLabelData }}
                                </h5> -->
                                <h5 align="left" class="tar-name-pricing" *ngIf="rate.labelData && rate.resumeLabelData == null">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    {{ rate.labelData }}
                                    <b *ngIf="rate.sublabelData">{{ rate.sublabelData }}</b>
                                </h5>
                                <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelVoice">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    <b> {{ rate.resumeLabelVoice }}</b>
                                </h5>

                                <!-- info Móvil -->
                                <!--<h5 align="left" class="tar-name-pricing">-->
                                    <!--<img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15" style="visibility: hidden">-->
                                    <!--+-->
                                <!--</h5>-->


                                <h5 align="left" class="tar-name-pricing" *ngIf="mobileRate.resumeLabelData">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    {{ mobileRate.resumeLabelData }}
                                </h5>
                                <h5 align="left" class="tar-name-pricing" *ngIf="mobileRate.labelData && mobileRate.resumeLabelData == null">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    {{ mobileRate.labelData }}
                                    <b *ngIf="mobileRate.sublabelData">{{ mobileRate.sublabelData }}</b>
                                </h5>
                                <h5 align="left" class="tar-name-pricing" *ngIf="mobileRate.resumeLabelVoice">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    {{ mobileRate.resumeLabelVoice }}
                                </h5>

                                <h5 align="left" class="tar-name-pricing" *ngIf="rate.discount > 0">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    <b> Te ahorras: {{ priceWithIVA(rate.discount).toFixed(0) }} <span class="eu2"> €/mes</span></b>
                                </h5>
                            </ul>

                            <ul class="mb-5">

                            </ul>
                            <div style="margin-top: -15px;">
                                <button (click)="selectPack(rate, mobileRate)" class="btn btn-green btn-sm btn-block">Seleccionar</button>
                                <button class="btn btn-grey btn-sm btn-block" (click)="modalMoreInfo(rate, mobileRate)">Más info</button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

        </ng-container>

        <!-- Resto de casos-->
        <ng-template #other_rates>
            <div class="col-lg-4" *ngFor="let rate of rates">
                <div class="card-tar card-white mb-4">
                    <div class="card-tar-header rm-verde">
                        <div class="d-flex justify-content-between align-items-center">
                            <h5 align="center" class="tar-name">{{ rate.name }}</h5>
                            <small class="text-muted">
                                <h5 *ngIf="rateFtth !== null" align="center" class="tar-name">
                                    {{ priceWithIVA(rate.rateAmount - rateFtth.discount).toFixed(0) }}
                                    <span class="eu2"> €/mes</span>
                                </h5>
                                <h5 *ngIf="rateFtth === null" align="center" class="tar-name">
                                    {{ priceWithIVA(rate.rateAmount).toFixed(0) }}
                                    <span class="eu2"> €/mes</span>
                                </h5>
                            </small>
                        </div>
                    </div>

                    <div class="card-tar-body">
                        <ul class="mb-5">
                            <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelData">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                {{ rate.resumeLabelData }}
                            </h5>
                            <h5 align="left" class="tar-name-pricing" *ngIf="rate.labelData && rate.resumeLabelData == null">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                <span *ngIf="rate.packageId === 'Pos_Micro' && showOffer"> {{ rate.labelData }} + {{ rate.resumeLabelVoice }}</span>
                                <span *ngIf="rate.packageId !== 'Pos_Micro' || !showOffer"> {{ rate.labelData }}</span>
                                <b *ngIf="rate.sublabelData">{{ rate.sublabelData }}</b>
                            </h5>

                            <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelVoice">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                <b *ngIf="rate.packageId === 'Pos_Micro' && showOffer" style="color: #fa405c;"> Excluida de la promoción +30GB</b>
                                <b *ngIf="rate.packageId !== 'Pos_Micro' || !showOffer"> {{ rate.resumeLabelVoice }}</b>
                            </h5>
                            <h5 align="left" class="tar-name-pricing" *ngIf="type === 'mobile'">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                Sin permanencia
                            </h5>
                        </ul>
                        <div style="margin-top: -15px;">
                            <button (click)="selectRate(rate)" class="btn btn-green btn-sm btn-block">Seleccionar</button>
                            <button class="btn btn-grey btn-sm btn-block" (click)="modalMoreInfo(rate)">Más info</button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</div>
<div *ngIf="!loaded" class="mt-2 mb-5">
    <h5 align="center" class="tar-name-preload">Obteniendo tarifas...</h5>

    <div align="center">
        <img class="" src="./assets/img/spinner_rm.svg" width="30" alt="">
    </div>
</div>

<ng-template #modalOffer let-modal>
    <div class="modal-header">
        <h5 class="modal-title white" id="exampleModalLabel">Promoción +30GB</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">
                <img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20">
            </span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row p-2">
            <div class="col-lg-12">
                <b>Promoción válida para altas/portabilidades móviles pospago hasta el 31 de agosto de 2020</b>
                <br>
                <span>Aplica a todas las líneas móviles pospago excepto las que contraten la tarifa cero</span>
                <br>
                <b>¿Cómo funciona?</b>
                <br>
                <span>Una vez que la línea del cliente esté activada el proceso es el siguiente:</span>
                <ul>
                    <li>Al día siguiente de la activación de su línea se le cargarán 10GB extras y se le enviará un SMS al cliente informándole.</li>
                    <li>Un mes después se le cargarán otros 10GB extras.</li>
                    <li>Un mes después se le cargarán otros 10GB extras.</li>
                    <li>Es decir, se distribuyen los 30GB gratis en 3 meses. Los GB que no haya consumido de un mes a otro se pierden.</li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>
